import React, { useRef, useState } from "react";
import "./Collapsible.css";
import { Button } from "devextreme-react/button"

interface IProps {
    expanded?: boolean;
    title: string;
    style?: React.CSSProperties;
    className?: string;
    children: React.ReactElement;
}

const Collapisble: React.FC<IProps> = ({ expanded, title, children, style, className }) => {
    const [isExpanded, setIsExpanded] = useState(expanded);
    const ref = useRef<HTMLDivElement>(null);

    const toggle = () => {
        setIsExpanded((prev) => !prev)
    }

    return <>
        <div style={style} className={className}>
            <div style={{ display: "flex" }}>
                <Button className="collapsible-button-header" icon={isExpanded ? "chevronup" : "chevrondown"} text={title} stylingMode="text" onClick={toggle} />
            </div>
            <div style={{ display: isExpanded ? "" : "none" }}>
                <div style={{ marginTop: "0.5rem" }} ref={ref}>
                    {isExpanded ? children : null}
                </div>
            </div>

        </div>
    </>
};

export default Collapisble;